export default __webpack_public_path__ + "static/media/fashion.091d3bf1.svg";